import { defineComponent as i, createElementBlock as o, createCommentVNode as m, openBlock as a, createElementVNode as c, toDisplayString as l } from "vue";
const s = ["alt", "src"], d = {
  key: 1,
  class: "header-name"
}, y = /* @__PURE__ */ i({
  __name: "HeaderItemMeta",
  props: {
    logo: {},
    projectName: {},
    primaryVersionUid: {}
  },
  emits: ["navigate"],
  setup(e, { emit: n }) {
    const r = n;
    return (g, t) => e.logo ? (a(), o("button", {
      key: 0,
      class: "header-item-logo",
      type: "button",
      onClick: t[0] || (t[0] = (u) => r("navigate", e.primaryVersionUid, "version"))
    }, [
      c("img", {
        alt: e.projectName,
        class: "header-item-logo-image",
        src: e.logo
      }, null, 8, s)
    ])) : e.projectName ? (a(), o("span", d, l(e.projectName), 1)) : m("", !0);
  }
});
export {
  y as default
};
